import { gql } from 'graphql.macro';

export const actionSubCategoryFragment = gql`
    fragment actionSubCategory on ActionSubCategory {
        _id
        name
        colorCode
        textColorCode
    }
`;

export const actionMaterialGroupFragment = gql`
    fragment actionMaterialGroup on ActionMaterialGroup {
        _id
        name
        materials {
            _id
            material
        }
        actionSet
    }
`;

export const actionCategoryFragment = gql`
    fragment actionCategory on ActionCategory {
        _id
        name
        colorCode
        textColorCode
        instructions
        subCategories {
            ...actionSubCategory
        }
        actionSet
    }
    ${actionSubCategoryFragment}
`;

export const basicActionSettingsOptionsFragment = gql`
    fragment basicActionSettingsOptions on BasicActionSettingsOptions {
        include
        mandatory
    }
`;

export const numberOfUnitSettingsOptionsFragment = gql`
    fragment numberOfUnitSettingsOptions on NumberOfUnitSettingsOptions {
        include
        mandatory
        isInteger
        numberOfDecimals
        header
    }
`;

export const actionSettingsFragment = gql`
    fragment actionSettings on ActionSettings {
        material {
            ...basicActionSettingsOptions
        }
        colorOrShade {
            ...basicActionSettingsOptions
        }
        design {
            ...basicActionSettingsOptions
        }
        contactType {
            ...basicActionSettingsOptions
        }
        occlusion {
            ...basicActionSettingsOptions
        }
        ponticDesign {
            ...basicActionSettingsOptions
        }
        retainment {
            ...basicActionSettingsOptions
        }
        implantSteps {
            ...basicActionSettingsOptions
        }
        dentureSteps {
            ...basicActionSettingsOptions
        }
        testingSteps {
            ...basicActionSettingsOptions
        }
        claspTeeth {
            ...basicActionSettingsOptions
        }
        claspMaterial {
            ...basicActionSettingsOptions
        }
        orthColor {
            ...basicActionSettingsOptions
        }
        facialLoop {
            ...basicActionSettingsOptions
        }
        claspType {
            ...basicActionSettingsOptions
        }
        springType {
            ...basicActionSettingsOptions
        }
        springTeeth {
            ...basicActionSettingsOptions
        }
        expansionScrew {
            ...basicActionSettingsOptions
        }
        protrusion {
            ...basicActionSettingsOptions
        }
        numberOfUnits {
            ...numberOfUnitSettingsOptions
        }
    }
    ${basicActionSettingsOptionsFragment}
    ${numberOfUnitSettingsOptionsFragment}
`;

export const actionActionFragment = gql`
    fragment actionAction on ActionAction {
        _id
        name
        number
        denthubRestorationType
        numberOfUnits
        teethOption
        mainCategory {
            ...actionCategory
        }
        subCategory {
            ...actionSubCategory
        }
        materialGroup {
            ...actionMaterialGroup
        }
        costPerTooth
        enable
        isNotesEnabled
        notes
        deliveryTime
        vat
        price
        rank
        quotable
        settings {
            ...actionSettings
        }
        actionSet
    }
    ${actionCategoryFragment}
    ${actionSubCategoryFragment}
    ${actionSettingsFragment}
    ${actionMaterialGroupFragment}
`;

export const connectedLabMaterialFragment = gql`
    fragment connectedLabMaterial on ConnectedLabMaterial {
        priceDiff
        material
        materialName
    }
`;

export const materialPriceDifferenceFragment = gql`
    fragment materialPriceDifference on MaterialPriceDifference {
        materials {
            ...connectedLabMaterial
        }
        materialGroupId
        actionSet
    }
    ${connectedLabMaterialFragment}
`;

export const connectedLabActionFragment = gql`
    fragment connectedLabAction on ConnectedLabAction {
        enable
        deliveryTime
        price
        action
    }
`;

export const priceListFragment = gql`
    fragment priceList on PriceList {
        actions {
            ...connectedLabAction
        }
        category
        actionSet
        rank
    }
    ${connectedLabActionFragment}
`;

export const actionSetFragment = gql`
    fragment actionSet on ActionSet {
        _id
        title
        categories {
            ...actionCategory
        }
        materialGroups {
            ...actionMaterialGroup
        }
        actions {
            ...actionAction
        }
    }
    ${actionCategoryFragment}
    ${actionMaterialGroupFragment}
    ${actionActionFragment}
`;
